module.exports = __webpack_public_path__ + "img/number_twelve.3c9a349c.jpg";